import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { DeploymentGroup } from 'types/api';
import { env } from 'config/env';
import { http, HttpResponse, delay } from 'msw';

type GetDeploymentGroupResponse = {
    deployment_group: DeploymentGroup;
};

export const getDeploymentGroup = async (
    deploymentGroupId: string,
): Promise<DeploymentGroup> => {
    const response = await api.get<
        GetDeploymentGroupResponse,
        GetDeploymentGroupResponse
    >(`/app/api/v1/deployment-groups/${deploymentGroupId}`);
    return response.deployment_group;
};

export const getDeploymentGroupQueryOptions = (deploymentGroupId: string) => {
    return queryOptions({
        queryKey: ['deployment_group', deploymentGroupId],
        queryFn: () => getDeploymentGroup(deploymentGroupId),
    });
};

type UseDeploymentGroupOptions = {
    deploymentGroupId: string;
    queryConfig?: QueryConfig<typeof getDeploymentGroupQueryOptions>;
};

export const useDeploymentGroup = ({
    deploymentGroupId,
    queryConfig,
}: UseDeploymentGroupOptions) => {
    return useQuery({
        ...getDeploymentGroupQueryOptions(deploymentGroupId),
        ...queryConfig,
    });
};

export const getDeploymentGroupMSWHandler = (
    deploymentGroup: DeploymentGroup,
) => {
    return http.get(
        `${env.API_URL}/app/api/v1/deployment-groups/:deploymentGroupId`,
        async () => {
            await delay(1000);
            return HttpResponse.json({ deployment_group: deploymentGroup });
        },
    );
};
